import React from "react";
import styled from "styled-components";
import moment from "moment";
import GraphImg from "graphcms-image";

import Icon from "../UI/Icon";
import baseStyles from "../../styles/baseStyles";

const Card = styled.div`
  height: 100%;
  box-shadow: ${({ active }) =>
    active ? baseStyles.layers.l5 : baseStyles.layers.l3};
  border-radius: 3px;
  background-color: ${baseStyles.color.white.o100};
  cursor: pointer;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: 0.2s 0.05s all ease-in-out;
  :hover {
    box-shadow: ${({ active }) =>
      active ? baseStyles.layers.l5 : baseStyles.layers.l4};
  }
  text-align: left;
`;
const EventTitle = styled.h4`
  font-family: Lato;
  font-size: 15px;
  color: ${baseStyles.color.darkGray};
  letter-spacing: 1.41px;
  margin: 0;
  margin-bottom: 0.5rem;
  font-weight: 400;
`;

const Image = styled(GraphImg)`
  object-fit: cover;
  height: 14rem;
  width: 100%;
  border-radius: 3px 3px 0 0;
`;

const Description = styled.span`
  font-family: Lato;
  font-size: 14px;
  color: ${baseStyles.color.lightGray};
  letter-spacing: 1.2px;
  font-weight: 300;
  margin-bottom: 0.5rem;
`;

const ContentWrapper = styled.div`
  margin: 1rem 2rem 2rem 2rem;
`;

const Link = styled.a`
  text-decoration: none;
  width: 100%;
`;

const LabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0;
`;

const Label = styled.span`
  font-family: Poppins-Light;
  font-size: 0.75rem;
  color: ${baseStyles.color.white2};
  letter-spacing: 1.2px;
  flex: 1;
  :not(:first-child) {
    margin-left: 1rem;
  }
`;

const JobCard = props => {
  const date = moment(props.date).format("MMM Do YY, h:mm a");
  return (
    <Card>
      <Link href={props.link} target="__blank">
        <Image image={props.image} withWebp max-width={600} alt={props.title} />
        <ContentWrapper>
          <EventTitle>{props.title}</EventTitle>
          <LabelContainer>
            <Label>{date}</Label>
            <Label>{props.locationName}</Label>
          </LabelContainer>
          <Description>{props.description}</Description>
        </ContentWrapper>
      </Link>
    </Card>
  );
};

export default JobCard;



// WEBPACK FOOTER //
// ./src/components/Events/EventCard.js